import { createErrorReporter, watchApiFetch, installBrowserErrors } from './systemErrorsCore';

const base = (process.env.REACT_APP_API_URL ?? 'http://localhost:3001').replace(/\/$/, '');
const enabled = process.env.REACT_APP_ERROR_LOGGING_ENABLED !== 'false';
const originalFetch =
  typeof window !== 'undefined' && typeof window.fetch === 'function'
    ? window.fetch.bind(window)
    : null;

export const systemErrors = createErrorReporter({
  enabled,
  platform: 'panel',
  version: require('../../package.json').version,
  getToken: () => {
    if (typeof window === 'undefined') return null;
    try {
      return window.localStorage.getItem('gise_panel_access_token');
    } catch {
      return null;
    }
  },
  getRoute: () => (typeof window === 'undefined' ? '' : window.location.pathname),
  send: async (errors, token) => {
    if (!originalFetch) return false;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    try {
      const response = await originalFetch(base + '/system-errors/report', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: 'Bearer ' + token } : {}),
        },
        body: JSON.stringify({ errors }),
        signal: controller.signal,
        keepalive: true,
      });
      return response.ok;
    } finally {
      clearTimeout(timeout);
    }
  },
});

let running = false;
export function startSystemErrors() {
  if (!enabled || typeof window === 'undefined') return () => {};
  if (running) return () => {};
  running = true;
  const undoFetch = watchApiFetch(window, base, systemErrors);
  const undoErrors = installBrowserErrors(window, systemErrors);
  return () => {
    undoErrors();
    undoFetch();
    running = false;
  };
}
export const reportSystemError = (error, context = {}) => systemErrors.capture(error, context);
